var map = {
	"./assets/img/default-room-brandless.jpg": "./src/assets/img/default-room-brandless.jpg",
	"./assets/img/default-room.jpg": "./src/assets/img/default-room.jpg",
	"./assets/img/fb_msg.jpg": "./src/assets/img/fb_msg.jpg",
	"./assets/img/fb_msg.png": "./src/assets/img/fb_msg.png",
	"./assets/img/hotel-img-grey.png": "./src/assets/img/hotel-img-grey.png",
	"./assets/img/hotel-img-nodata.svg": "./src/assets/img/hotel-img-nodata.svg",
	"./assets/img/hotel-img-room.jpg": "./src/assets/img/hotel-img-room.jpg",
	"./assets/img/hotel-img.png": "./src/assets/img/hotel-img.png",
	"./assets/img/line.svg": "./src/assets/img/line.svg",
	"./assets/img/msg.png": "./src/assets/img/msg.png",
	"./assets/img/payment-logo/logo-applepay.png": "./src/assets/img/payment-logo/logo-applepay.png",
	"./assets/img/payment-logo/logo-creditcard.png": "./src/assets/img/payment-logo/logo-creditcard.png",
	"./assets/img/payment-logo/logo-intella-alipay.png": "./src/assets/img/payment-logo/logo-intella-alipay.png",
	"./assets/img/payment-logo/logo-intella-linepay.png": "./src/assets/img/payment-logo/logo-intella-linepay.png",
	"./assets/img/payment-logo/logo-intella-wechatpay.png": "./src/assets/img/payment-logo/logo-intella-wechatpay.png",
	"./assets/img/payment-logo/logo-linepay.png": "./src/assets/img/payment-logo/logo-linepay.png",
	"./assets/img/payment-logo/logo-owlpay-checkout.svg": "./src/assets/img/payment-logo/logo-owlpay-checkout.svg",
	"./assets/img/payment-logo/logo-paynow-creditcard.png": "./src/assets/img/payment-logo/logo-paynow-creditcard.png",
	"./assets/img/payment-logo/logo-paynow-creditcard3d.png": "./src/assets/img/payment-logo/logo-paynow-creditcard3d.png",
	"./assets/img/payment-logo/logo-paypal.png": "./src/assets/img/payment-logo/logo-paypal.png",
	"./assets/img/payment-logo/logo-sony.png": "./src/assets/img/payment-logo/logo-sony.png",
	"./assets/img/payment-logo/logo-stripe-futurepay.png": "./src/assets/img/payment-logo/logo-stripe-futurepay.png",
	"./assets/img/payment-logo/logo-stripe-singlepay.png": "./src/assets/img/payment-logo/logo-stripe-singlepay.png",
	"./assets/img/payment-logo/logo-taiwan-travel.png": "./src/assets/img/payment-logo/logo-taiwan-travel.png",
	"./assets/img/payment-logo/logo-unionpay.png": "./src/assets/img/payment-logo/logo-unionpay.png",
	"./assets/img/paypal.svg": "./src/assets/img/paypal.svg",
	"./assets/img/xmark.png": "./src/assets/img/xmark.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src sync recursive \\.jpg$|\\.png$|\\.svg$";